import axios from 'axios'
import { sha256 } from 'js-sha256';
import base64url from "base64url";
import config from '@/config'

const API_URL = config.API_URL

export default {
  state: {
    departments_data: [],
    answers_data: [],
  },
  mutations: {
    departmentsDataMutatuon: (state, response) => state.departments_data = response,
    fetchAnswersMutatuon: (state, response) => state.answers_data = response,
  },
  actions: {
    async departmentsList(ctx){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      await axios.get(
        `${API_URL}/api/rest/receipt/sprav_otd?secret_key=${key}`,
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        }, 
        
      ).then((response) => {
        localStorage.setItem('weltumTimeAuth', Date.now())
        ctx.commit('departmentsDataMutatuon', response.data.items)
      })
    },
    async sendFeedBackForm(ctx, postData){
      const key = localStorage.getItem("weltumKey")

      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      await axios.post(
        `${API_URL}/api/rest/receipt/put_feedback`,
          postData,
          {
            headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Hmac': Hmac,
            'X-Time': Time, 
            }
          },
        
      ).then((/*response*/) => {
        localStorage.setItem('weltumTimeAuth', Date.now())
      })
    },
    async fetchAnswers(ctx){
      const item = window.location.pathname.split('/').pop()
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      await axios.get(
        `${API_URL}/api/rest/receipt/feedback_answer?lico=${item}&secret_key=${key}`,
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((response) => {
        localStorage.setItem('weltumTimeAuth', Date.now())
        ctx.commit('fetchAnswersMutatuon', response.data.items)
      })
    },
    async deleteMessageAction(ctx, message){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      await axios.post(
        `${API_URL}/api/rest/receipt/feedback_upd`,
        message,
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((/*response*/) => {
        localStorage.setItem('weltumTimeAuth', Date.now())
      })
    }
  },
  getters:{
    departmentsData: s => s.departments_data,
    answersData: s => s.answers_data,
  },
}